import type { DeepPartial, Theme } from '@fanadise/common-types';
import { THEME_PREFIX } from 'consts/themePrefix';
import { createThemeCssVariables } from 'utils/createThemeCssVariables';

export const createThemeStyles = (
  theme: DeepPartial<Theme>,
  selector: string = ':root',
  prefix: string = THEME_PREFIX,
): string => `${selector} {${createThemeCssVariables(theme, prefix)}}`;
